import * as R from 'ramda'

export const FINANCE_TABLE_PADDING_X_SPACING_VALUE = 3
export const FINANCE_TABLE_CELL_HEIGHT = 40

export const FINANCE_CELL_WIDTH = {
  ACTIONS: 115,
  CREATION_DATE: 152,
  DISCOUNT: 115,
  PRODUCER: 174,
  QUANTITY: 115,
  REFUNDED: 120,
  SUBTOTAL: 133,
  TAX: 115,
  UNIT_PRICE: 115,
}

export const REFUND_TABLE_MIN_WIDTH = R.sum(R.values(FINANCE_CELL_WIDTH))
